module.exports = __webpack_public_path__ + "img/9788952751126.ff66dc44.jpg";